export default __webpack_public_path__ + "static/media/gs-6.bd420299.png";